
package io.horion.cv.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.icons.fa.FaMagnifyingGlass
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.icons.fa.FaLocationDot
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.utils.Constants.INTER

@OptIn(DelicateApi::class)
@Composable
fun JobActionBar(
    isUser: Boolean,
    isDark: Boolean,
    isMobile: Boolean) {

    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .position(Position.Sticky) //pour rester sur place meme si on scrolle
            .top(0.px)
            .zIndex(10)
            .backgroundColor(if (!isDark)Colors.White else Colors.holder)
            .padding(topBottom = 12.px)
            .borderBottom(1.px, LineStyle.Solid, Colors.LightGray)
    ) {
        if (isMobile) {

            Column(
                modifier = Modifier
                    .fillMaxWidth(90.percent)
                    .margin(leftRight = 20.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Box(modifier = Modifier.fillMaxWidth().padding( bottom = 15.px),
                    contentAlignment = Alignment.Center){
                    SearchBar(
                        onEnterClick = {},
                        onSearchIconClick = {},
                        breakpoint = breakpoint,
                    )
                }

                // Boutons à droite
                Row(
                    horizontalArrangement = Arrangement.spacedBy(10.px)
                ) {
                    Button(
                        attrs = Modifier
                            .fontFamily(INTER)
                            .fontSize(if (isMobile) 14.px else 16.px)
                            .cursor(Cursor.Pointer)
                            .toAttrs {
                                classes("btn", "btn-primary")
                                onClick {
                                    if (isUser){
                                        ctx.router.navigateTo("/job/consulter")
                                    }else{
                                        ctx.router.navigateTo("/job/recruteur")
                                    }
                                }
                            }
                    ) {
                        Text(if (isUser) "Mes Candidatures" else "Gerer mes postes")
                    }
                    Button(
                        attrs = Modifier
                            .fontFamily(INTER)
                            .fontSize(if (isMobile) 14.px else 16.px)
                            .color(if (isDark) Colors.White else Colors.Blue)
                            .border(
                                1.px,
                                style = LineStyle.Solid,
                                color = if (isDark) Colors.White else Colors.Blue
                            )
                            .cursor(Cursor.Pointer)
                            .toAttrs {
                                classes("btn", "btn-outline-primary")
                                onClick {
                                    ctx.router.navigateTo("/job/create")
                                }
                            }
                    ) {
                        Text(" un poste")
                    }
                }
            }
            }
        else{
            Row(
                    modifier = Modifier
                        .fillMaxWidth(90.percent)
                        .margin(leftRight = 30.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {

                    // espace vide à gauche
                    Box()

                    // Barre de recherche
                    Box(modifier = Modifier.fillMaxWidth(if (isMobile) 30.percent else 60.percent),
                        contentAlignment = Alignment.Center){
                        SearchBar(
                            onEnterClick = {},
                            onSearchIconClick = {},
                            breakpoint = breakpoint,
                        )
                    }

                    // Boutons à droite
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(10.px)
                    ) {
                        Button(
                            attrs = Modifier
                                .fontFamily(INTER)
                                .fontSize(if (isMobile) 14.px else 16.px)
                                .cursor(Cursor.Pointer)
                                .toAttrs {
                                    classes("btn", "btn-primary")
                                    onClick {
                                        if (isUser){
                                            ctx.router.navigateTo("/job/consulter")
                                        }else{
                                            ctx.router.navigateTo("/job/recruteur")
                                        }
                                    }
                                }
                        ) {
                            Text(if (isUser) "Mes Candidatures" else "Gerer mes postes")
                        }
                        Button(
                            attrs = Modifier
                                .fontFamily(INTER)
                                .fontSize(if (isMobile) 14.px else 16.px)
                                .color(if (isDark) Colors.White else Colors.Blue)
                                .border(
                                    1.px,
                                    style = LineStyle.Solid,
                                    color = if (isDark) Colors.White else Colors.Blue
                                )
                                .cursor(Cursor.Pointer)
                                .toAttrs {
                                    classes("btn", "btn-outline-primary")
                                    onClick {
                                        ctx.router.navigateTo("/job/create")
                                    }
                                }
                        ) {
                            Text("Créer un poste")
                        }
                    }
                }
            }
    }
}
